// extracted by mini-css-extract-plugin
export default {"wsc_floating_button":"floating-button_wsc_wsc_floating_button__d5KiQ"};